import { render, staticRenderFns } from "./crudCurrency.vue?vue&type=template&id=27bdbe22&"
import script from "./crudCurrency.vue?vue&type=script&lang=js&"
export * from "./crudCurrency.vue?vue&type=script&lang=js&"
import style0 from "./crudCurrency.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports